define('NSeComm.CustomPackages.Main', [
    'custom_package_configurator.tpl',
    'NSeComm.CustomPackages.Styles'
], function (
    configuratorTpl,
    stylesCss
) {
    'use strict';

    return {

        data: null,
        packagesByAnchor: {},
        container: null,
        cartUrl: '/cart',
        // My Account request-a-quote page; quote-only packages hand off here
        quoteUrl: '/scs/my_account.ssp#request-a-quote',
        // matrix-flow state (one configurator is active per PDP)
        mx: null,

        // localStorage key shared with NSeComm.CustomPackages.QuoteBridge
        // (the MyAccount entry point that merges pending lines into the
        // draft quote request after login)
        QUOTE_PENDING_KEY: 'cpkg_quote_pending',

        // The configurator's CSS ships in NSeComm.CustomPackages.Styles
        // (built from styles/_custom-packages-main.scss) instead of the
        // Extension Manager Sass step, which fails to read this
        // extension's scss on activation. Injected once per page.
        injectStyles: function injectStyles() {
            try {
                if (!stylesCss || document.getElementById('cpkg-styles')) { return; }
                var el = document.createElement('style');
                el.id = 'cpkg-styles';
                el.appendChild(document.createTextNode(stylesCss));
                (document.head || document.documentElement).appendChild(el);
            } catch (e) {
                if (window.console) { window.console.warn('CustomPackages: styles not injected', e); }
            }
        },

        // ─── Entry point ───
        mountToApp: function mountToApp(container) {
            var self = this;
            this.container = container;
            this.injectStyles();

            var environment = container.getComponent('Environment');
            if (!environment) { return; }

            var dataUrl = environment.getConfig('customPackages.dataUrl');
            this.cartUrl = environment.getConfig('customPackages.cartUrl') || '/cart';
            this.quoteUrl = environment.getConfig('customPackages.quoteUrl') ||
                '/scs/my_account.ssp#request-a-quote';
            if (!dataUrl) { return; }

            // Bind BEFORE the feed request: on a first visit the PDP's
            // afterShowContent often fires before the feed returns, and a
            // listener bound afterwards never sees it (configurator silently
            // missing on roughly 1 in 3 loads). handlePdp waits for the
            // data; the feed callback below catches up on the current PDP.
            this.bindPdp();
            this.bindCart();

            // Native fetch, NOT jQuery.ajax: SCA's ajaxPrefilter stamps a
            // custom X-SC-Touchpoint header on every jQuery request, which
            // turns this cross-origin GET into a preflighted request the
            // anonymous Suitelet cannot answer. fetch() sends no custom
            // headers, so the browser issues a simple CORS GET and the
            // Suitelet's Access-Control-Allow-Origin: * response suffices.
            window.fetch(dataUrl).then(function (response) {
                if (!response.ok) { throw new Error('HTTP ' + response.status); }
                return response.json();
            }).then(function (data) {
                self.data = data || { packages: [], items: {} };
                self.data.items = self.data.items || {};
                (self.data.packages || []).forEach(function (pkg) {
                    if (pkg.anchorItemId) {
                        self.packagesByAnchor[String(pkg.anchorItemId)] = pkg;
                    }
                });
                var pdp = self.container.getComponent('PDP');
                if (pdp) {
                    try {
                        self.handlePdp(pdp);
                    } catch (e) {
                        if (window.console) { window.console.error('CustomPackages PDP error', e); }
                    }
                }
            }).catch(function () {
                if (window.console) {
                    window.console.warn('CustomPackages: could not load the package feed.');
                }
            });
        },

        // ─── PDP take-over ───
        bindPdp: function bindPdp() {
            var self = this;
            var pdp = this.container.getComponent('PDP');
            if (!pdp || !pdp.on) { return; }

            pdp.on('afterShowContent', function () {
                try {
                    self.handlePdp(pdp);
                } catch (e) {
                    if (window.console) { window.console.error('CustomPackages PDP error', e); }
                }
            });
        },

        handlePdp: function handlePdp(pdp) {
            // Feed not loaded yet: the feed callback calls back in.
            if (!this.data) { return; }
            // Older PDP components expose getProductInfo; current ones (this
            // site's SCS 26.x) expose getItemInfo. Support both.
            var info = (pdp.getProductInfo && pdp.getProductInfo()) ||
                (pdp.getItemInfo && pdp.getItemInfo()) || null;
            var itemId = this.extractItemId(info);
            if (!itemId) { return; }

            var pkg = this.packagesByAnchor[String(itemId)];
            if (!pkg) {
                // SPA navigation can reuse the sticky add-to-cart node we
                // hid on an anchor PDP — restore it on ordinary items.
                jQuery('.cart-add-to-cart-button-container').removeClass('cpkg-native-hidden');
                return;
            }
            if (jQuery('#cpkg-configurator').length) { return; }

            this.renderConfigurator(pkg);
        },

        extractItemId: function extractItemId(info) {
            if (!info) { return null; }
            return info._id || info.internalid || info.internalId || info.id ||
                (info.item && (info.item.internalid || info.item._id)) || null;
        },

        isMatrix: function isMatrix(pkg) {
            return !!(pkg.solutions && pkg.solutions.length);
        },

        renderConfigurator: function renderConfigurator(pkg) {
            // Manor / "full" PDP layout (SCS 26.x on this site): the theme's
            // own .product-details-information is a narrow buy-box column, so
            // mount into a dedicated full-width host inserted just below the
            // image/buy-box columns instead.
            var $info;
            var $fullMain = jQuery('.product-details-full-main-content').first();
            if ($fullMain.length) {
                $info = jQuery('.cpkg-fullwidth-host').first();
                if (!$info.length) {
                    $info = jQuery('<div class="cpkg-fullwidth-host"></div>').insertAfter($fullMain);
                }
            } else {
                $info = jQuery('.product-details-information').first();
                if (!$info.length) { $info = jQuery('.product-details-content').first(); }
                if (!$info.length) { $info = jQuery('.product-details-content-wrapper').first(); }
                if (!$info.length) { $info = jQuery('.product-details-full-content').first(); }
            }
            if (!$info.length) { return; }

            // Hide the standard purchase controls — the configurator replaces
            // them. Scope to the whole PDP so it works when the configurator
            // mounts outside the buy-box column.
            var $scope = jQuery('.product-details-full').first();
            if (!$scope.length) { $scope = $info; }
            $scope.find([
                '.product-details-options',
                '.product-views-price',
                '.product-details-quantity',
                '.product-details-quantity-container',
                '.product-details-quantity-options',
                '.quantity-pricing-container',
                '.product-details-add-to-cart-button',
                '.product-details-information-add-to-cart',
                '[data-action="add-to-cart"]',
                // native wishlist / add-to-quote buttons: the configurator's
                // own quote flow replaces them on the anchor-item PDP
                '.product-list-control-button-wishlist',
                '.product-detail-to-quote-add-to-quote-button'
            ].join(',')).addClass('cpkg-native-hidden');

            // The sticky quick add-to-cart renders on PURCHASABLE anchor
            // items (the priced respirator; the price-hidden cabinet never
            // shows one) and can sit outside the PDP scope — hide it
            // document-wide; handlePdp restores it on ordinary items.
            jQuery('.cart-add-to-cart-button-container, [data-action="sticky"]')
                .addClass('cpkg-native-hidden');

            // In their place, point the shopper at the configurator below.
            var $buyBox = jQuery('.product-details-full-main-content-right').first();
            if ($buyBox.length && !$buyBox.find('.cpkg-build-pointer').length) {
                var noun = /cabinet/i.test(pkg.name || '') ? 'Cabinet' : 'Package';
                jQuery(
                    '<div class="cpkg-build-pointer">' +
                    '<p>Configure your ' + noun.toLowerCase() + ' and request a quote below.</p>' +
                    '<button type="button" class="cpkg-build-pointer-btn">' +
                    'Build Your ' + noun + ' &darr;</button></div>'
                ).appendTo($buyBox).find('.cpkg-build-pointer-btn').on('click', function () {
                    var host = document.querySelector('.cpkg-fullwidth-host');
                    if (host && host.scrollIntoView) {
                        host.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            }

            if (!jQuery('#cpkg-configurator').length) {
                $info.append(configuratorTpl());
            }
            this.fillShell(pkg, jQuery('#cpkg-configurator'));
        },

        fillShell: function fillShell(pkg, $shell) {
            if (!$shell.length) { return; }
            if (this.isMatrix(pkg)) {
                this.mxReset(pkg);
                this.mxRender(pkg, $shell);
            } else {
                $shell.html(this.buildConfiguratorHtml(pkg));
                this.bindConfiguratorEvents(pkg, $shell);
                this.recalculate(pkg, $shell);
            }
        },

        /* ════════════════════════════════════════════════════════════════
         *  MATRIX FLOW
         *  Option groups act as ordered filters over pkg.solutions; each
         *  option carries a `code` and each solution the list of codes it
         *  satisfies. After every group has a selection, the surviving
         *  solutions are offered; picking one unlocks its accessories,
         *  service spares, and the package's smart add-ons.
         * ════════════════════════════════════════════════════════════════ */

        mxReset: function mxReset(pkg) {
            this.mx = {
                selections: {},      // groupId -> { code, optionId, label }
                solutionId: null,
                acc: {},             // itemId -> qty
                spares: {},          // itemId -> qty
                smart: {}            // smartPkgId -> true
            };
        },

        mxGroups: function mxGroups(pkg) {
            // Only groups whose options carry codes participate in filtering.
            return (pkg.groups || []).filter(function (g) {
                return (g.options || []).some(function (o) { return o.code; });
            });
        },

        mxSelectedSolution: function mxSelectedSolution(pkg) {
            var id = this.mx.solutionId;
            if (!id) { return null; }
            var found = null;
            (pkg.solutions || []).forEach(function (s) {
                if (String(s.id) === String(id)) { found = s; }
            });
            return found;
        },

        // Solutions surviving the selections of groups[0..uptoIdx-1]
        // (pass groups.length to apply every selection).
        mxFilterSolutions: function mxFilterSolutions(pkg, groups, uptoIdx) {
            var mx = this.mx;
            var sols = (pkg.solutions || []).slice();
            for (var i = 0; i < uptoIdx && i < groups.length; i++) {
                var sel = mx.selections[groups[i].id];
                if (!sel) { continue; }
                sols = sols.filter(function (s) {
                    return (s.codes || []).indexOf(sel.code) !== -1;
                });
            }
            return sols;
        },

        mxOptionAvailable: function mxOptionAvailable(pkg, groups, gi, code) {
            var sols = this.mxFilterSolutions(pkg, groups, gi);
            return sols.some(function (s) {
                return (s.codes || []).indexOf(code) !== -1;
            });
        },

        mxComplete: function mxComplete(pkg, groups) {
            var mx = this.mx;
            return groups.every(function (g) { return !!mx.selections[g.id]; });
        },

        mxMatching: function mxMatching(pkg, groups) {
            if (!this.mxComplete(pkg, groups)) { return []; }
            return this.mxFilterSolutions(pkg, groups, groups.length);
        },

        mxSelectedLabels: function mxSelectedLabels(pkg, groups) {
            var mx = this.mx;
            return groups.map(function (g) {
                return mx.selections[g.id] ? mx.selections[g.id].label : null;
            }).filter(Boolean);
        },

        item: function item(id) {
            return (this.data.items || {})[String(id)] || null;
        },

        // ─── Stock ───
        // The feed sends items[].available: null for types NetSuite doesn't
        // stock-track (treated as always available), otherwise the live
        // quantity. We sell from inventory: in-stock choices list first and
        // only in-stock choices are preselected.
        inStock: function inStock(info) {
            return !info || info.available === null || info.available === undefined ||
                info.available > 0;
        },
        // positiveOnly: solution cards (whole cabinets/hoods) only advertise
        // stock positively — configured units are routinely built to order,
        // and a wall of "Special Order" solution cards reads as a warning.
        // Parts lists show both states.
        stockBadge: function stockBadge(info, positiveOnly) {
            if (!info || info.available === null || info.available === undefined) { return ''; }
            if (info.available > 0) {
                return '<span class="cpkg-stock cpkg-stock-in">In Stock</span>';
            }
            return positiveOnly ? '' :
                '<span class="cpkg-stock cpkg-stock-out">Special Order</span>';
        },
        // Stable partition: in-stock entries keep their order ahead of
        // special-order entries. getInfo maps an entry to its item info.
        stockFirst: function stockFirst(list, getInfo) {
            var self = this;
            var inS = [], out = [];
            (list || []).forEach(function (e) {
                (self.inStock(getInfo(e)) ? inS : out).push(e);
            });
            return inS.concat(out);
        },

        // ─── Item photos ───
        // An item's photo URL is ALWAYS its urlcomponent + "_01.jpg" in the
        // Item Images hosting folder (site convention — Brett, 2026-09-21).
        imgUrl: function imgUrl(info) {
            return (info && info.url) ?
                '/img/Item Images/' + info.url + '_01.jpg' : '';
        },
        // Thumbnail that quietly removes itself when the photo is missing.
        thumbHtml: function thumbHtml(info, cls) {
            var src = this.imgUrl(info);
            if (!src) { return ''; }
            return '<img class="' + cls + '" loading="lazy" alt="" src="' +
                this.esc(src) + '" onerror="this.parentNode&&this.parentNode.removeChild(this)">';
        },

        // ─── Accessory display grouping ───
        // Cosmetic sub-categories for the checklists, matched on display
        // names. A list where nothing matches renders flat exactly as
        // before (the cabinet package), so this only shapes lists that
        // speak this vocabulary.
        ACC_CATEGORIES: [
            { label: 'Climate Control', re: /air tube|climate control|c40|air condition/i },
            { label: 'Breathing Air Hose', re: /breathing hose|air supply hose/i },
            { label: 'Air Filtration', re: /airline filter|breathing air filter|air filter/i },
            { label: 'CO Monitoring', re: /co monitor|gas monitor/i },
            { label: 'Air Supply Connection', re: /crowfoot|quick disconnect|coupler/i },
            { label: 'Lenses', re: /lens/i },
            { label: 'Operator Gear', re: /blast suit|blast glove|stretch hood|blast jacket/i }
        ],
        accCategoryIndex: function accCategoryIndex(info) {
            var name = (info && info.name) || '';
            for (var i = 0; i < this.ACC_CATEGORIES.length; i++) {
                if (this.ACC_CATEGORIES[i].re.test(name)) { return i; }
            }
            return -1;
        },

        // Price visibility: hidePrices comes from the anchor item's native
        // "Don't Show Price" (which also forces quote-only). A package can
        // instead be quote-only via its own checkbox and still SHOW prices —
        // hidePrices stays false. Any single item can be price-hidden the
        // same way inside a priced package.
        priceHidden: function priceHidden(pkg, thing) {
            return !!(pkg.hidePrices || (thing && thing.priceHidden));
        },

        ctaLabel: function ctaLabel(pkg) {
            return pkg.quoteOnly ? 'Add Package to Quote Request' : 'Add Package to Cart';
        },

        // ─── State transitions ───

        mxPickOption: function mxPickOption(pkg, groups, gi, optionId) {
            var g = groups[gi];
            var opt = null;
            (g.options || []).forEach(function (o) {
                if (String(o.id) === String(optionId)) { opt = o; }
            });
            if (!opt) { return; }

            var prev = this.mx.selections[g.id];
            if (prev && String(prev.optionId) === String(opt.id)) { return; }
            this.mx.selections[g.id] = { code: opt.code, optionId: opt.id, label: opt.label };

            if (prev && prev.code === opt.code) {
                // Only the sub-label changed (e.g. ALOX -> Garnet): downstream
                // selections and the solution stay valid, but preselected
                // add-ons are label-dependent, so re-apply them. Smart-package
                // picks are label-independent — keep them.
                if (this.mx.solutionId) {
                    var keepSmart = this.mx.smart;
                    this.mxPickSolution(pkg, groups, this.mx.solutionId);
                    this.mx.smart = keepSmart;
                }
                return;
            }

            // A different code invalidates everything downstream of this group.
            for (var i = gi + 1; i < groups.length; i++) {
                delete this.mx.selections[groups[i].id];
            }
            this.mx.solutionId = null;
            this.mx.acc = {};
            this.mx.spares = {};
            this.mx.smart = {};
        },

        mxPickSolution: function mxPickSolution(pkg, groups, solutionId) {
            this.mx.solutionId = solutionId;
            this.mx.acc = {};
            this.mx.spares = {};
            this.mx.smart = {};
            var sol = this.mxSelectedSolution(pkg);
            if (!sol) { return; }

            var labels = this.mxSelectedLabels(pkg, groups);
            var self = this;
            var preselectAllowed = function (itemId) {
                var info = self.item(itemId);
                // Never preselect a special-order part — we sell from stock.
                if (!self.inStock(info)) { return false; }
                var when = (sol.preselectWhen || {})[info ? info.sku : ''];
                if (!when || !when.length) { return true; }
                return when.some(function (lbl) { return labels.indexOf(lbl) !== -1; });
            };

            (sol.preselected || []).forEach(function (itemId) {
                if ((sol.accessories || []).indexOf(itemId) === -1) { return; }
                if (preselectAllowed(itemId)) { self.mx.acc[itemId] = 1; }
            });
            (sol.preselectedSpares || []).forEach(function (itemId) {
                if ((sol.spares || []).indexOf(itemId) === -1) { return; }
                if (preselectAllowed(itemId)) { self.mx.spares[itemId] = 1; }
            });
        },

        mxConflictOf: function mxConflictOf(sol, itemId) {
            // exclusivePairs is by SKU: [["CC 23147","CC 23146"], ...]
            var info = this.item(itemId);
            if (!info || !sol.exclusivePairs) { return null; }
            for (var i = 0; i < sol.exclusivePairs.length; i++) {
                var pair = sol.exclusivePairs[i];
                var idx = pair.indexOf(info.sku);
                if (idx !== -1) {
                    var otherSku = pair[idx === 0 ? 1 : 0];
                    // resolve back to an item id within this solution
                    var lists = (sol.accessories || []).concat(sol.spares || []);
                    for (var j = 0; j < lists.length; j++) {
                        var other = this.item(lists[j]);
                        if (other && other.sku === otherSku) { return lists[j]; }
                    }
                }
            }
            return null;
        },

        mxStep: function mxStep(pkg, kind, itemId, delta) {
            var sol = this.mxSelectedSolution(pkg);
            if (!sol) { return; }
            var bag = kind === 'spare' ? this.mx.spares : this.mx.acc;
            var qty = (bag[itemId] || 0) + delta;
            var isMax1 = (sol.maxQty1 || []).indexOf(String(itemId)) !== -1;
            if (isMax1 && qty > 1) { qty = 1; }
            if (qty <= 0) {
                delete bag[itemId];
            } else {
                if (delta > 0) {
                    var conflict = this.mxConflictOf(sol, itemId);
                    if (conflict) {
                        delete this.mx.acc[conflict];
                        delete this.mx.spares[conflict];
                    }
                }
                bag[itemId] = qty;
            }
        },

        // Click anywhere on an accessory row: add it (qty 1) or take it
        // back out. Quantities above one stay on the +/- steppers.
        mxToggleRow: function mxToggleRow(pkg, kind, itemId) {
            var bag = kind === 'spare' ? this.mx.spares : this.mx.acc;
            if (bag[itemId]) {
                delete bag[itemId];
                return;
            }
            this.mxStep(pkg, kind, itemId, 1);
        },

        mxToggleSmart: function mxToggleSmart(pkg, spId) {
            var sp = null;
            (pkg.smartPackages || []).forEach(function (s) {
                if (String(s.id) === String(spId)) { sp = s; }
            });
            if (!sp) { return; }
            if (this.mx.smart[spId]) {
                delete this.mx.smart[spId];
                return;
            }
            // blocked while its conflict is selected
            if (sp.conflictsWith && this.mx.smart[sp.conflictsWith]) { return; }
            this.mx.smart[spId] = true;
        },

        // ─── Totals / cart lines ───

        mxLines: function mxLines(pkg) {
            var self = this;
            var lines = [];
            var sol = this.mxSelectedSolution(pkg);
            if (sol && sol.itemId) {
                lines.push({
                    itemId: String(sol.itemId), quantity: 1,
                    label: sol.name || sol.sku, price: sol.price || 0
                });
            }
            var pushBag = function (bag) {
                Object.keys(bag).forEach(function (itemId) {
                    var info = self.item(itemId);
                    lines.push({
                        itemId: String(itemId), quantity: bag[itemId],
                        label: info ? (info.name || info.sku) : ('Item ' + itemId),
                        price: info ? info.price : 0
                    });
                });
            };
            pushBag(this.mx.acc);
            pushBag(this.mx.spares);
            Object.keys(this.mx.smart).forEach(function (spId) {
                (pkg.smartPackages || []).forEach(function (sp) {
                    if (String(sp.id) === String(spId) && sp.itemId) {
                        lines.push({
                            itemId: String(sp.itemId), quantity: 1,
                            label: sp.label, price: sp.price || 0
                        });
                    }
                });
            });
            return lines;
        },

        mxTotal: function mxTotal(pkg) {
            return this.mxLines(pkg).reduce(function (t, l) {
                return t + (l.price || 0) * l.quantity;
            }, 0);
        },

        // ─── Rendering ───

        mxRender: function mxRender(pkg, $shell) {
            var self = this;
            var groups = this.mxGroups(pkg);

            var html = '<div class="cpkg-mx">';
            html += '<div class="cpkg-mx-options">';

            html += '<div class="cpkg-head cpkg-mx-head">';
            if (pkg.headline) {
                html += '<h2 class="cpkg-headline">' + self.esc(pkg.headline) + '</h2>';
            }
            if (pkg.subhead) {
                html += '<p class="cpkg-subhead">' + self.esc(pkg.subhead) + '</p>';
            }
            html += '<button type="button" class="cpkg-mx-reset" data-cpkg="reset">&#8635; Reset</button>';
            html += '</div>';

            groups.forEach(function (g, gi) {
                html += self.mxGroupHtml(pkg, groups, g, gi);
            });

            if (this.mxComplete(pkg, groups)) {
                html += self.mxSolutionsHtml(pkg, groups);
            }

            var sol = this.mxSelectedSolution(pkg);
            if (sol) {
                html += self.mxAccessoriesHtml(pkg, sol, 'acc', 'Accessories & Upgrades', sol.accessories);
                html += self.mxAccessoriesHtml(pkg, sol, 'spare', 'Service Spares', sol.spares);
                html += self.mxSmartHtml(pkg);
            }

            html += '</div>'; // .cpkg-mx-options
            html += self.mxSummaryHtml(pkg, groups);
            html += '</div>'; // .cpkg-mx

            $shell.html(html);
            this.mxBind(pkg, $shell);
        },

        mxGroupHtml: function mxGroupHtml(pkg, groups, g, gi) {
            var self = this;
            var mx = this.mx;
            var sel = mx.selections[g.id];
            // A group is actionable once every earlier group is selected.
            var reachable = groups.slice(0, gi).every(function (pg) {
                return !!mx.selections[pg.id];
            });

            var html = '<fieldset class="cpkg-group cpkg-mx-group' +
                (reachable ? '' : ' cpkg-mx-group-locked') + '" data-group="' + g.id + '">';
            html += '<legend class="cpkg-group-title">';
            html += '<span class="cpkg-step-num">' + (gi + 1) + '</span>';
            html += '<span class="cpkg-step-label">' + self.esc(g.label) + '</span>';
            if (sel) {
                html += '<span class="cpkg-mx-chosen">' + self.esc(sel.label) + '</span>';
            }
            html += '</legend>';
            if (g.help) {
                html += '<p class="cpkg-group-help">' + self.esc(g.help) + '</p>';
            }

            // Option photo: when an option's code narrows to exactly one
            // solution (each respirator hood), show that solution's product
            // shot on the card. Cabinet codes match many solutions → no
            // photo, and those cards render as compact chips like before.
            var optImgUrl = function (o) {
                var match = null, count = 0;
                (pkg.solutions || []).forEach(function (s) {
                    if ((s.codes || []).indexOf(o.code) !== -1) { match = s; count++; }
                });
                if (count !== 1 || !match) { return ''; }
                return match.image || self.imgUrl(self.item(match.itemId));
            };

            html += '<div class="cpkg-mx-optrow">';
            (g.options || []).forEach(function (o) {
                if (!o.code) { return; }
                var available = reachable && self.mxOptionAvailable(pkg, groups, gi, o.code);
                var chosen = sel && String(sel.optionId) === String(o.id);
                var oi = optImgUrl(o);
                html += '<button type="button" class="cpkg-mx-opt' +
                    (chosen ? ' cpkg-mx-opt-on' : '') + '"' +
                    ' data-cpkg="opt" data-gi="' + gi + '" data-option="' + o.id + '"' +
                    (available ? '' : ' disabled') +
                    (o.blurb ? ' title="' + self.esc(o.blurb) + '"' : '') + '>';
                if (oi) {
                    html += '<img class="cpkg-mx-opt-img" loading="lazy" alt="" src="' +
                        self.esc(oi) + '" onerror="this.parentNode&&this.parentNode.removeChild(this)">';
                }
                html += '<span class="cpkg-mx-opt-label">' + self.esc(o.label);
                if (o.blurb) { html += '<span class="cpkg-mx-info">i</span>'; }
                html += '</span></button>';
            });
            html += '</div></fieldset>';
            return html;
        },

        mxSolutionsHtml: function mxSolutionsHtml(pkg, groups) {
            var self = this;
            var matches = this.mxMatching(pkg, groups);
            var chosenId = this.mx.solutionId;

            var html = '<div class="cpkg-mx-section">';
            html += '<h3 class="cpkg-mx-section-title">Recommended Solutions' +
                '<span class="cpkg-mx-count">' + matches.length + '</span></h3>';
            if (!matches.length) {
                html += '<p class="cpkg-group-help">No solution matches this exact combination. ' +
                    'Try a different size or blast type.</p>';
            }
            matches = this.stockFirst(matches, function (s) { return self.item(s.itemId); });
            matches.forEach(function (s) {
                var chosen = chosenId && String(chosenId) === String(s.id);
                html += '<div class="cpkg-sol' + (chosen ? ' cpkg-sol-on' : '') + '"' +
                    ' data-cpkg="sol" data-solution="' + s.id + '">';
                var simg = s.image || self.imgUrl(self.item(s.itemId));
                if (simg) {
                    html += '<img class="cpkg-sol-img" loading="lazy" alt="" src="' + self.esc(simg) +
                        '" onerror="this.parentNode&&this.parentNode.removeChild(this)">';
                }
                html += '<div class="cpkg-sol-body">';
                html += '<div class="cpkg-sol-name">' + self.esc(s.name || s.sku) + '</div>';
                if (s.sku) { html += '<div class="cpkg-option-sku">' + self.esc(s.sku) + '</div>'; }
                html += self.stockBadge(self.item(s.itemId), true);
                if (s.specs && s.specs.length) {
                    html += '<div class="cpkg-sol-specs">';
                    s.specs.forEach(function (b) {
                        html += '<span class="cpkg-sol-badge">' + self.esc(b) + '</span>';
                    });
                    html += '</div>';
                }
                html += '</div>';
                html += '<div class="cpkg-sol-side">';
                html += '<div class="cpkg-sol-price">' +
                    ((self.priceHidden(pkg, s) || !s.price) ? 'Price on request' : self.fmt(s.price)) + '</div>';
                html += '<span class="cpkg-sol-pick">' + (chosen ? 'Selected &#10003;' : 'Select') + '</span>';
                html += '</div></div>';
            });
            html += '</div>';
            return html;
        },

        mxAccessoriesHtml: function mxAccessoriesHtml(pkg, sol, kind, title, itemIds) {
            var self = this;
            if (!itemIds || !itemIds.length) { return ''; }
            var bag = kind === 'spare' ? this.mx.spares : this.mx.acc;

            // Sub-category first (only when this list speaks the category
            // vocabulary — otherwise flat), then upgrades, then in-stock
            // before special-order, then alphabetical.
            var entries = itemIds.map(function (id) {
                var info = self.item(id);
                return { id: id, info: info, cat: self.accCategoryIndex(info) };
            }).filter(function (e) { return !!e.info; });
            var grouped = entries.some(function (e) { return e.cat !== -1; });
            entries.sort(function (a, b) {
                if (grouped) {
                    var ca = a.cat === -1 ? 999 : a.cat;
                    var cb = b.cat === -1 ? 999 : b.cat;
                    if (ca !== cb) { return ca - cb; }
                }
                var ua = a.info.upgrade ? 0 : 1;
                var ub = b.info.upgrade ? 0 : 1;
                if (ua !== ub) { return ua - ub; }
                var sa = self.inStock(a.info) ? 0 : 1;
                var sb = self.inStock(b.info) ? 0 : 1;
                if (sa !== sb) { return sa - sb; }
                var na = (a.info.name || '').toLowerCase();
                var nb = (b.info.name || '').toLowerCase();
                return na < nb ? -1 : na > nb ? 1 : 0;
            });
            if (!entries.length) { return ''; }

            var html = '<div class="cpkg-mx-section">';
            html += '<h3 class="cpkg-mx-section-title">' + self.esc(title) + '</h3>';
            var lastCat = null;
            entries.forEach(function (e) {
                if (grouped && e.cat !== lastCat) {
                    lastCat = e.cat;
                    html += '<h4 class="cpkg-acc-subhead">' + self.esc(
                        e.cat === -1 ? 'More' : self.ACC_CATEGORIES[e.cat].label
                    ) + '</h4>';
                }
                var qty = bag[e.id] || 0;
                var conflictId = self.mxConflictOf(sol, e.id);
                var blocked = conflictId &&
                    (self.mx.acc[conflictId] || self.mx.spares[conflictId]);
                var max1 = (sol.maxQty1 || []).indexOf(String(e.id)) !== -1;

                // The whole row toggles the item; the +/- keep working for
                // quantities beyond one.
                html += '<div class="cpkg-acc' + (qty ? ' cpkg-acc-on' : '') +
                    (blocked ? ' cpkg-acc-blocked' : '') + '"' +
                    ' data-cpkg="accrow" data-kind="' + kind + '" data-item="' + e.id + '">';
                html += self.thumbHtml(e.info, 'cpkg-acc-img');
                html += '<div class="cpkg-acc-body">';
                html += '<span class="cpkg-acc-name">' + self.esc(e.info.name);
                if (e.info.upgrade) { html += ' <span class="cpkg-acc-upgrade">Upgrade</span>'; }
                html += '</span>';
                html += '<span class="cpkg-option-sku">' + self.esc(e.info.sku) + '</span>';
                html += self.stockBadge(e.info);
                if (e.info.tooltip) {
                    html += '<span class="cpkg-option-blurb">' + self.esc(self.blurb(e.info.tooltip)) + '</span>';
                }
                if (blocked) {
                    var other = self.item(conflictId);
                    html += '<span class="cpkg-acc-conflict">Not compatible with ' +
                        self.esc(other ? other.name : 'the selected option') + '</span>';
                }
                html += '</div>';
                html += '<div class="cpkg-acc-side">';
                html += '<span class="cpkg-option-price">' +
                    ((self.priceHidden(pkg, e.info) || !e.info.price) ? '&mdash;' : self.fmt(e.info.price)) + '</span>';
                html += '<span class="cpkg-qty">';
                html += '<button type="button" class="cpkg-qty-btn" data-cpkg="step"' +
                    ' data-kind="' + kind + '" data-item="' + e.id + '" data-delta="-1"' +
                    (qty ? '' : ' disabled') + '>&minus;</button>';
                html += '<span class="cpkg-qty-num">' + qty + '</span>';
                html += '<button type="button" class="cpkg-qty-btn" data-cpkg="step"' +
                    ' data-kind="' + kind + '" data-item="' + e.id + '" data-delta="1"' +
                    ((blocked || (max1 && qty >= 1)) ? ' disabled' : '') + '>+</button>';
                html += '</span></div></div>';
            });
            html += '</div>';
            return html;
        },

        mxSmartHtml: function mxSmartHtml(pkg) {
            var self = this;
            var sps = pkg.smartPackages || [];
            if (!sps.length) { return ''; }

            var html = '<div class="cpkg-mx-section">';
            html += '<h3 class="cpkg-mx-section-title">Smart Packages</h3>';
            sps.forEach(function (sp) {
                var on = !!self.mx.smart[sp.id];
                var blocked = sp.conflictsWith && self.mx.smart[sp.conflictsWith];
                html += '<div class="cpkg-acc cpkg-smart' + (on ? ' cpkg-acc-on' : '') +
                    (blocked ? ' cpkg-acc-blocked' : '') + '"' +
                    (blocked ? '' : ' data-cpkg="smart" data-smart="' + sp.id + '"') + '>';
                html += '<div class="cpkg-acc-body">';
                html += '<span class="cpkg-acc-name">' + self.esc(sp.label) + '</span>';
                if (sp.sku) { html += '<span class="cpkg-option-sku">' + self.esc(sp.sku) + '</span>'; }
                html += self.stockBadge(self.item(sp.itemId));
                if (sp.description) {
                    html += '<span class="cpkg-option-blurb">' + self.esc(self.blurb(sp.description)) + '</span>';
                }
                if (blocked) {
                    html += '<span class="cpkg-acc-conflict">Not compatible with the selected airflow package</span>';
                }
                html += '</div>';
                html += '<div class="cpkg-acc-side">';
                html += '<span class="cpkg-option-price">' +
                    ((self.priceHidden(pkg, sp) || !sp.price) ? '&mdash;' : self.fmt(sp.price)) + '</span>';
                html += '<span class="cpkg-smart-check">' + (on ? '&#10003;' : '+') + '</span>';
                html += '</div></div>';
            });
            html += '</div>';
            return html;
        },

        mxSummaryHtml: function mxSummaryHtml(pkg, groups) {
            var self = this;
            var mx = this.mx;
            var html = '<div class="cpkg-mx-summary">';
            html += '<h3 class="cpkg-mx-section-title">Configuration Summary</h3>';

            html += '<table class="cpkg-mx-seltable"><tbody>';
            groups.forEach(function (g) {
                var sel = mx.selections[g.id];
                html += '<tr><td>' + self.esc(g.label) + '</td><td>' +
                    (sel ? self.esc(sel.label) : '<span class="cpkg-mx-tbd">&mdash;</span>') +
                    '</td></tr>';
            });
            html += '</tbody></table>';

            var lines = this.mxLines(pkg);
            if (lines.length) {
                html += '<div class="cpkg-summary-rows">';
                lines.forEach(function (l) {
                    html += '<div class="cpkg-summary-row"><span>' + self.esc(l.label) +
                        (l.quantity > 1 ? ' &times;' + l.quantity : '') + '</span><span>' +
                        ((pkg.hidePrices || !l.price) ? '&mdash;' : self.fmt(l.price * l.quantity)) +
                        '</span></div>';
                });
                html += '</div>';
            } else {
                html += '<p class="cpkg-group-help">Select options to build your configuration.</p>';
            }

            if (pkg.hidePrices) {
                html += '<div class="cpkg-total-row"><span>Package total</span>' +
                    '<span class="cpkg-quoted-note">Provided with your quote</span></div>';
            } else {
                var discount = 0;
                var total = this.mxTotal(pkg);
                if (pkg.discountPct && total) {
                    discount = total * (pkg.discountPct / 100);
                    html += '<div class="cpkg-summary-row cpkg-discount"><span>Package discount (' +
                        pkg.discountPct + '%)</span><span>-' + self.fmt(discount) + '</span></div>';
                }
                html += '<div class="cpkg-total-row"><span>Package total</span>' +
                    '<span id="cpkg-total">' + self.fmt(total - discount) + '</span></div>';
            }
            html += '<button type="button" class="cpkg-add-btn" id="cpkg-add-btn"' +
                (this.mx.solutionId ? '' : ' disabled') + '>' + self.ctaLabel(pkg) + '</button>';
            if (pkg.quoteOnly && this.mx.solutionId) {
                html += '<div class="cpkg-msg">Your items are added to a quote request for our team to price — no payment online.</div>';
            } else if (!this.mx.solutionId) {
                html += '<div class="cpkg-msg cpkg-msg-warn">Choose your options and select a solution.</div>';
            } else {
                html += '<div class="cpkg-msg" id="cpkg-msg"></div>';
            }
            html += '</div>';
            return html;
        },

        mxBind: function mxBind(pkg, $shell) {
            var self = this;
            var groups = this.mxGroups(pkg);
            $shell.off('click.cpkg');

            $shell.on('click.cpkg', '[data-cpkg="opt"]', function () {
                var $b = jQuery(this);
                self.mxPickOption(pkg, groups, parseInt($b.data('gi'), 10), $b.data('option'));
                self.mxRender(pkg, $shell);
            });

            $shell.on('click.cpkg', '[data-cpkg="sol"]', function () {
                self.mxPickSolution(pkg, groups, jQuery(this).data('solution'));
                self.mxRender(pkg, $shell);
            });

            $shell.on('click.cpkg', '[data-cpkg="step"]', function (ev) {
                ev.stopPropagation();
                var $b = jQuery(this);
                self.mxStep(pkg, $b.data('kind'), String($b.data('item')),
                    parseInt($b.data('delta'), 10));
                self.mxRender(pkg, $shell);
            });

            $shell.on('click.cpkg', '[data-cpkg="accrow"]', function (ev) {
                // clicks on the qty control (including its disabled buttons)
                // never toggle the row
                if (jQuery(ev.target).closest('.cpkg-qty').length) { return; }
                var $r = jQuery(this);
                self.mxToggleRow(pkg, $r.data('kind'), String($r.data('item')));
                self.mxRender(pkg, $shell);
            });

            $shell.on('click.cpkg', '[data-cpkg="smart"]', function () {
                self.mxToggleSmart(pkg, jQuery(this).data('smart'));
                self.mxRender(pkg, $shell);
            });

            $shell.on('click.cpkg', '[data-cpkg="reset"]', function () {
                self.mxReset(pkg);
                self.mxRender(pkg, $shell);
            });

            $shell.on('click.cpkg', '#cpkg-add-btn', function () {
                self.mxAddToCart(pkg, $shell);
            });
        },

        mxAddToCart: function mxAddToCart(pkg, $shell) {
            var self = this;
            var lines = this.mxLines(pkg).map(function (l) {
                return { itemId: l.itemId, quantity: l.quantity };
            });
            if (!lines.length) { return; }

            if (pkg.quoteOnly) {
                this.sendToQuote(pkg, $shell, lines);
                return;
            }

            var cart = self.container.getComponent('Cart');
            if (!cart || !cart.addLine) {
                self.showMsg($shell, 'The cart is unavailable right now. Please try again.', true);
                return;
            }

            var $btn = $shell.find('#cpkg-add-btn');
            $btn.prop('disabled', true).text('Adding…');

            self.addLinesSequential(cart, lines).done(function () {
                self.rememberGroup(pkg, lines);
                self.mxShowSuccess($shell, pkg, lines.length);
            }).fail(function (e) {
                if (window.console) { window.console.error('CustomPackages addToCart', e); }
                self.showMsg($shell, 'Sorry, something went wrong adding the package.', true);
                $btn.prop('disabled', false).text(self.ctaLabel(pkg));
            });
        },

        mxShowSuccess: function mxShowSuccess($shell, pkg, count) {
            var self = this;
            var html = '<div class="cpkg-success">';
            html += '<div class="cpkg-success-icon">&#10003;</div>';
            html += '<h3>Package added to your cart</h3>';
            html += '<p>' + count + ' item' + (count === 1 ? '' : 's') + ' from <strong>' +
                self.esc(pkg.name) + '</strong> ' + (count === 1 ? 'was' : 'were') + ' added.</p>';
            html += '<a class="cpkg-view-cart" href="' + self.esc(self.cartUrl) + '">' +
                'View Cart &rarr;</a>';
            html += '<button type="button" class="cpkg-reconfigure" id="cpkg-reconfigure">' +
                'Configure Another</button>';
            html += '</div>';

            $shell.find('.cpkg-mx-summary').html(html);
            $shell.find('#cpkg-reconfigure').on('click', function () {
                self.fillShell(pkg, $shell);
            });
        },

        /* ════════════════════════════════════════════════════════════════
         *  QUOTE-ONLY HANDOFF
         *  Quote-only packages don't touch the cart. The lines are stashed
         *  in localStorage and the shopper is sent to the native My Account
         *  "Request a Quote" wizard (NetSuite enforces login on the way).
         *  NSeComm.CustomPackages.QuoteBridge — this extension's MyAccount
         *  entry point — picks the stash up there and adds the items to the
         *  wizard's Request-a-Quote product list (internalid "quote"), the
         *  same store the native "Add to Quote" button uses.
         * ════════════════════════════════════════════════════════════════ */

        sendToQuote: function sendToQuote(pkg, $shell, lines) {
            var $btn = $shell.find('#cpkg-add-btn');
            try {
                window.localStorage.setItem(this.QUOTE_PENDING_KEY, JSON.stringify({
                    name: pkg.name,
                    lines: lines,
                    ts: Date.now()
                }));
            } catch (e) {
                this.showMsg($shell,
                    'We could not start your quote request. Please call us or use Request a Quote in My Account.',
                    true);
                return;
            }
            $btn.prop('disabled', true).text('Opening your quote request…');

            // The wizard requires login, and NetSuite's login bounce is a
            // server-side 302 that DROPS the #request-a-quote fragment —
            // an anonymous shopper sent to quoteUrl ends up stranded on the
            // My Account overview after signing in. For guests, go via the
            // login page with origin_hash instead: SCA's login/registration
            // flow restores the fragment on the customercenter touchpoint.
            // (QuoteBridge still catches any stragglers on the overview.)
            var loggedIn = false;
            try {
                var ProfileModel = require('Profile.Model');
                loggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
            } catch (e) { /* unknown -> treat as guest; login page passes members through */ }

            if (loggedIn) {
                window.location.href = this.quoteUrl;
            } else {
                var hash = this.quoteUrl.split('#')[1] || 'request-a-quote';
                window.location.href = '/scs/checkout.ssp?is=login&login=T' +
                    '&origin=customercenter&origin_hash=' + encodeURIComponent(hash);
            }
        },

        /* ════════════════════════════════════════════════════════════════
         *  STEPS FLOW (original) — independent option groups, no matrix.
         * ════════════════════════════════════════════════════════════════ */

        // ─── Markup ───
        buildConfiguratorHtml: function buildConfiguratorHtml(pkg) {
            var self = this;
            var html = '';

            html += '<div class="cpkg-head">';
            if (pkg.headline) {
                html += '<h2 class="cpkg-headline">' + self.esc(pkg.headline) + '</h2>';
            }
            if (pkg.subhead) {
                html += '<p class="cpkg-subhead">' + self.esc(pkg.subhead) + '</p>';
            }
            html += '</div>';

            (pkg.groups || []).forEach(function (g, gi) {
                // In-stock options list (and default) first — sell from stock.
                var options = self.stockFirst(g.options || [], function (o) {
                    return o.itemId ? self.item(o.itemId) : null;
                });
                var optInStock = function (o) {
                    return !o.itemId || self.inStock(self.item(o.itemId));
                };
                var defaultOptId = null;
                if (!g.multi) {
                    options.forEach(function (o) {
                        if (defaultOptId === null && o.isDefault && optInStock(o)) {
                            defaultOptId = o.id;
                        }
                    });
                    if (defaultOptId === null) {
                        options.forEach(function (o) {
                            if (defaultOptId === null && optInStock(o)) { defaultOptId = o.id; }
                        });
                    }
                    if (defaultOptId === null && options.length) {
                        defaultOptId = options[0].id;
                    }
                }

                html += '<fieldset class="cpkg-group" data-group="' + g.id + '"' +
                    ' data-required="' + (g.required ? '1' : '0') + '"' +
                    ' data-label="' + self.esc(g.label) + '">';
                html += '<legend class="cpkg-group-title">';
                html += '<span class="cpkg-step-num">' + (gi + 1) + '</span>';
                html += '<span class="cpkg-step-label">' + self.esc(g.label) + '</span>';
                if (g.required) { html += '<span class="cpkg-req">Required</span>'; }
                html += '</legend>';
                if (g.help) {
                    html += '<p class="cpkg-group-help">' + self.esc(g.help) + '</p>';
                }

                var inputType = g.multi ? 'checkbox' : 'radio';
                options.forEach(function (o) {
                    var checked = g.multi ? (!!o.isDefault && optInStock(o)) :
                        (o.id === defaultOptId);
                    html += '<label class="cpkg-option">';
                    html += '<input type="' + inputType + '" class="cpkg-input"' +
                        ' name="cpkg_group_' + g.id + '"' +
                        ' data-group="' + g.id + '"' +
                        ' data-option="' + o.id + '"' +
                        ' data-item="' + self.esc(o.itemId) + '"' +
                        ' data-qty="' + (o.qty || 1) + '"' +
                        ' data-price="' + (o.price || 0) + '"' +
                        (checked ? ' checked' : '') + '>';
                    html += '<span class="cpkg-option-body">';
                    html += '<span class="cpkg-option-label">' + self.esc(o.label) + '</span>';
                    if (o.blurb) {
                        html += '<span class="cpkg-option-blurb">' + self.esc(o.blurb) + '</span>';
                    }
                    if (o.sku) {
                        html += '<span class="cpkg-option-sku">' + self.esc(o.sku) + '</span>';
                    }
                    if (o.itemId) { html += self.stockBadge(self.item(o.itemId)); }
                    html += '</span>';
                    var hidePrice = self.priceHidden(pkg, o);
                    html += '<span class="cpkg-option-price">' +
                        ((!hidePrice && o.price) ? self.fmt(o.price * (o.qty || 1)) : '') + '</span>';
                    html += '</label>';
                });
                html += '</fieldset>';
            });

            html += '<div class="cpkg-summary">';
            html += '<div class="cpkg-summary-rows" id="cpkg-summary-rows"></div>';
            if (pkg.hidePrices) {
                html += '<div class="cpkg-total-row"><span>Package total</span>' +
                    '<span class="cpkg-quoted-note">Provided with your quote</span></div>';
            } else {
                html += '<div class="cpkg-total-row"><span>Package total</span>' +
                    '<span id="cpkg-total">' + self.fmt(0) + '</span></div>';
            }
            html += '<button type="button" class="cpkg-add-btn" id="cpkg-add-btn">' +
                self.ctaLabel(pkg) + '</button>';
            html += '<div class="cpkg-msg" id="cpkg-msg"></div>';
            html += '</div>';

            return html;
        },

        // ─── Events ───
        bindConfiguratorEvents: function bindConfiguratorEvents(pkg, $shell) {
            var self = this;
            $shell.off('change.cpkg click.cpkg');
            $shell.on('change.cpkg', '.cpkg-input', function () {
                self.recalculate(pkg, $shell);
            });
            $shell.on('click.cpkg', '#cpkg-add-btn', function () {
                self.addToCart(pkg, $shell);
            });
        },

        recalculate: function recalculate(pkg, $shell) {
            var self = this;
            var selections = self.getSelections($shell);
            var subtotal = 0;
            var rowsHtml = '';

            selections.forEach(function (s) {
                subtotal += s.price * s.qty;
                rowsHtml += '<div class="cpkg-summary-row"><span>' + self.esc(s.label) +
                    (s.qty > 1 ? ' &times;' + s.qty : '') + '</span><span>' +
                    ((!pkg.hidePrices && s.price) ? self.fmt(s.price * s.qty) : '&mdash;') + '</span></div>';
            });

            // No discount row in the steps flow: the estimate-marker UE can
            // only find (and discount) matrix-flow packages on the quote, so
            // showing a percentage here would promise money the quote never
            // contains. Matrix summaries (mxSummaryHtml) do show it.
            var discount = 0;

            $shell.find('#cpkg-summary-rows').html(rowsHtml);
            $shell.find('#cpkg-total').text(self.fmt(subtotal - discount));
            self.syncCheckedClasses($shell);

            var missing = self.getMissingRequired($shell);
            var $btn = $shell.find('#cpkg-add-btn');
            var $msg = $shell.find('#cpkg-msg');
            $btn.prop('disabled', missing.length > 0);
            if (missing.length) {
                $msg.text('Please choose: ' + missing.join(', ')).addClass('cpkg-msg-warn');
            } else {
                $msg.text('').removeClass('cpkg-msg-warn');
            }
        },

        // Reliable checked-state styling for browsers without :has() support.
        syncCheckedClasses: function syncCheckedClasses($shell) {
            $shell.find('.cpkg-option').each(function () {
                var $opt = jQuery(this);
                $opt.toggleClass('cpkg-option-checked',
                    $opt.find('.cpkg-input').is(':checked'));
            });
        },

        getSelections: function getSelections($shell) {
            var sels = [];
            $shell.find('.cpkg-input:checked').each(function () {
                var $i = jQuery(this);
                sels.push({
                    groupId: $i.data('group'),
                    optionId: $i.data('option'),
                    itemId: $i.data('item'),
                    qty: parseInt($i.data('qty'), 10) || 1,
                    price: parseFloat($i.data('price')) || 0,
                    label: jQuery.trim($i.closest('.cpkg-option').find('.cpkg-option-label').text())
                });
            });
            return sels;
        },

        getMissingRequired: function getMissingRequired($shell) {
            var missing = [];
            $shell.find('.cpkg-group').each(function () {
                var $g = jQuery(this);
                if (String($g.data('required')) === '1' &&
                    !$g.find('.cpkg-input:checked').length) {
                    missing.push($g.data('label'));
                }
            });
            return missing;
        },

        // ─── Add to cart ───
        addToCart: function addToCart(pkg, $shell) {
            var self = this;
            var selections = self.getSelections($shell);
            var lines = [];
            selections.forEach(function (s) {
                if (s.itemId) {
                    lines.push({ itemId: String(s.itemId), quantity: s.qty });
                }
            });
            if (!lines.length) { return; }

            if (pkg.quoteOnly) {
                self.sendToQuote(pkg, $shell, lines);
                return;
            }

            var cart = self.container.getComponent('Cart');
            if (!cart || !cart.addLine) {
                self.showMsg($shell, 'The cart is unavailable right now. Please try again.', true);
                return;
            }

            var $btn = $shell.find('#cpkg-add-btn');
            $btn.prop('disabled', true).text('Adding…');

            self.addLinesSequential(cart, lines).done(function () {
                self.rememberGroup(pkg, lines);
                self.showSuccess($shell, pkg, lines.length);
            }).fail(function (e) {
                if (window.console) { window.console.error('CustomPackages addToCart', e); }
                self.showMsg($shell, 'Sorry, something went wrong adding the package.', true);
                $btn.prop('disabled', false).text(self.ctaLabel(pkg));
            });
        },

        // Adds lines one at a time so the cart stays consistent.
        addLinesSequential: function addLinesSequential(cart, lines) {
            var dfd = jQuery.Deferred();
            var i = 0;
            function next() {
                if (i >= lines.length) { dfd.resolve(); return; }
                var line = lines[i];
                i += 1;
                try {
                    jQuery.when(cart.addLine(line)).then(next, function (err) {
                        dfd.reject(err);
                    });
                } catch (e) {
                    dfd.reject(e);
                }
            }
            next();
            return dfd.promise();
        },

        showSuccess: function showSuccess($shell, pkg, count) {
            var self = this;
            var html = '<div class="cpkg-success">';
            html += '<div class="cpkg-success-icon">&#10003;</div>';
            html += '<h3>Package added to your cart</h3>';
            html += '<p>' + count + ' item' + (count === 1 ? '' : 's') + ' from <strong>' +
                self.esc(pkg.name) + '</strong> ' + (count === 1 ? 'was' : 'were') + ' added.</p>';
            html += '<a class="cpkg-view-cart" href="' + self.esc(self.cartUrl) + '">' +
                'View Cart &rarr;</a>';
            html += '<button type="button" class="cpkg-reconfigure" id="cpkg-reconfigure">' +
                'Configure Another</button>';
            html += '</div>';

            $shell.find('.cpkg-summary').html(html);
            $shell.find('#cpkg-reconfigure').on('click', function () {
                self.fillShell(pkg, $shell);
            });
        },

        showMsg: function showMsg($shell, text, isWarn) {
            var $msg = $shell.find('#cpkg-msg');
            $msg.text(text);
            $msg[isWarn ? 'addClass' : 'removeClass']('cpkg-msg-warn');
        },

        // ─── Cart-page grouping (best effort, theme dependent) ───
        bindCart: function bindCart() {
            var self = this;
            try {
                var cart = this.container.getComponent('Cart');
                if (cart && cart.on) {
                    cart.on('afterShowContent', function () {
                        try { self.decorateCart(); } catch (e) { /* non-fatal */ }
                    });
                }
            } catch (e) { /* non-fatal */ }
        },

        rememberGroup: function rememberGroup(pkg, lines) {
            try {
                var store = JSON.parse(window.sessionStorage.getItem('cpkg_groups') || '[]');
                store.push({
                    name: pkg.name,
                    items: lines.map(function (l) { return String(l.itemId); }),
                    ts: Date.now()
                });
                window.sessionStorage.setItem('cpkg_groups', JSON.stringify(store));
            } catch (e) { /* non-fatal */ }
        },

        decorateCart: function decorateCart() {
            var store;
            try {
                store = JSON.parse(window.sessionStorage.getItem('cpkg_groups') || '[]');
            } catch (e) { return; }
            if (!store || !store.length) { return; }

            store.forEach(function (grp) {
                (grp.items || []).forEach(function (itemId) {
                    var $row = jQuery('[data-item-id="' + itemId + '"]').not('.cpkg-grouped-line');
                    if (!$row.length) { return; }
                    $row.addClass('cpkg-grouped-line');
                    if (!$row.find('.cpkg-line-badge').length) {
                        $row.find('.cart-line-name, .item-views-cell-navigable')
                            .first()
                            .prepend('<span class="cpkg-line-badge">' +
                                jQuery('<div>').text(grp.name).html() + '</span>');
                    }
                });
            });
        },

        // ─── Helpers ───
        // Blurbs may originate from rich-text item fields (store description);
        // the feed strips markup server-side, but guard here too: drop any
        // tags/entities that slip through and keep blurbs to one short line.
        blurb: function blurb(s) {
            var text = String(s == null ? '' : s)
                .replace(/<[^>]+>/g, ' ')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&amp;/gi, '&')
                .replace(/&lt;/gi, '<')
                .replace(/&gt;/gi, '>')
                .replace(/&quot;/gi, '"')
                .replace(/&#0*39;|&apos;/gi, "'")
                .replace(/\s+/g, ' ')
                .trim();
            if (text.length > 180) {
                var cut = text.lastIndexOf(' ', 180);
                text = text.slice(0, cut > 60 ? cut : 180).replace(/[,;:.\s]+$/, '') + '…';
            }
            return text;
        },

        esc: function esc(s) {
            return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
                return ({
                    '&': '&amp;', '<': '&lt;', '>': '&gt;',
                    '"': '&quot;', "'": '&#39;'
                })[c];
            });
        },

        fmt: function fmt(n) {
            n = Number(n) || 0;
            return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    };
});
